/** Contatos do suporte (opcionais), configurados por variáveis de ambiente da plataforma. */
const email = (import.meta.env.VITE_SUPPORT_EMAIL as string | undefined)?.trim() || null;
const whatsapp =
  (import.meta.env.VITE_SUPPORT_WHATSAPP as string | undefined)?.replace(/\D/g, '') || null;

export const SUPPORT_EMAIL: string | null = email;
export const SUPPORT_WHATSAPP_URL: string | null = whatsapp
  ? `https://wa.me/${whatsapp}?text=${encodeURIComponent('Olá! Preciso de ajuda com o LD Gestão.')}`
  : null;
